import { StdResponse, request } from "@/global/config/request";
import { GlobalMonitorParameter, GlobalMonitorParameterFunc } from "@/global/interface/lib-device/global-monitor-parameter";


export function getGlobalMonitorParameterDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-monitor-parameters/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalMonitorParameter(data: GlobalMonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-monitor-parameters`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalMonitorParameter(id: number, data: GlobalMonitorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/global-monitor-parameters/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalMonitorParameter(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-monitor-parameters/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalMonitorParameters(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-monitor-parameters`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得某全局监测参数的计算方法
 * 
 * @param id 全局监测参数id
 */
export function getFunctionsByParameterId(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-monitor-parameters/${id}/funcs`, {
        params: {
            ...params,
        }
    })
}
/**
 * 获得某计算方法的详情
 * 
 * @param uuid 监测方法uuid
 */
export function getFunctionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/global-monitor-parameters/funcs/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function addMonitorParameterFunc(id: number, data: GlobalMonitorParameterFunc, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/global-monitor-parameters/${id}/funcs`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteMonitorParameterFunc(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/global-monitor-parameters/funcs/${uuid}`, {
        params: {
            ...params,
        }
    })
}